import React from 'react';
import { WalkerLocationV6, WalkerProfileV6 } from '../../../../types/api';
import { PCGTab } from '../../PCGProfileContainer';
import { WalkerAvatar } from './WalkerAvatar';
import { WagRecommended } from './WagRecommended';
import { WalkerLocation } from './WalkerLocation';
import { WalkerRating } from './WalkerRating';
import { WalkerDistance } from './WalkerDistance';
import { WalkerCatchphrase } from './WalkerCatchphrase';
import { WalkerAttributes } from './WalkerAttributes';
import { WalkerTabs } from './WalkerTabs';
import { Box } from '../../../../wag-react/next-components/box';
import { Typography } from '../../../../wag-react/components/Typography';
type Props = {
  profile: WalkerProfileV6;
  location: WalkerLocationV6;
  setSelectedTab: React.Dispatch<React.SetStateAction<PCGTab>>;
  selectedTab: PCGTab;
  pcgTabs: PCGTab[];
  totalReviews: number | null;
};
export const PCGDetails = ({
  profile,
  location,
  setSelectedTab,
  selectedTab,
  pcgTabs,
  totalReviews
}: Props) => <Box display="flex" flexDirection={['column', 'column', 'row']} data-sentry-element="Box" data-sentry-component="PCGDetails" data-sentry-source-file="index.tsx">
    <Box width={['92%', '92%', '100%']} mx="auto" display={['initial', 'flex']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <Box display="flex" flexDirection={['column', 'column', 'row']} width={['100%', '70%']} position="relative" pt={['30px', '16px']} pb={[0, '12px']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <WalkerAvatar containerProps={{
        position: ['absolute', 'relative', 'relative'],
        top: ['-56px', '0px'],
        mr: [0, 3]
      }} imgSrc={profile?.photo} isPromoted={profile?.promoted} data-sentry-element="WalkerAvatar" data-sentry-source-file="index.tsx" />
        <Box py={[0, 2]} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Box display="flex" alignItems="center" width="100%" data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <Typography variant="h3" color="#272727" fontFamily="muliBold" m="0" mr={[2]} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              {profile?.firstName}
              {' '}
              {profile?.lastName}
            </Typography>
            {profile?.promoted && <WagRecommended />}
          </Box>

          <WalkerLocation location={`${location.city}, ${location.administrativeAreaLevel1}, ${location.postalCode}`} data-sentry-element="WalkerLocation" data-sentry-source-file="index.tsx" />

          <Box display="flex" mb={[2]} data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <WalkerRating averageRating={profile.averageRating} totalReviews={totalReviews || 0} containerProps={{
            mr: '8px'
          }} data-sentry-element="WalkerRating" data-sentry-source-file="index.tsx" />

            {location.distance && <WalkerDistance distance={location.distance} />}
          </Box>

          {profile.catchphrase && <WalkerCatchphrase catchphrase={profile.catchphrase} containerProps={{
          mb: ['16px', 5],
          mt: [3, '12px']
        }} />}

        </Box>
      </Box>

      <Box as="hr" height="1px" bg="#DADCDB" display={['block', 'none']} opacity={0.3} data-sentry-element="Box" data-sentry-source-file="index.tsx" />
      <WalkerAttributes completedServices={profile.completedServices.all} repeatBookings={profile.repeatClients} containerProps={{
      mt: [3, '24px'],
      mb: [2, '12px'],
      width: ['100%', '30%']
    }} tags={profile.tags} data-sentry-element="WalkerAttributes" data-sentry-source-file="index.tsx" />
    </Box>

    <WalkerTabs setSelectedTab={setSelectedTab} selectedTab={selectedTab} pcgTabs={pcgTabs} data-sentry-element="WalkerTabs" data-sentry-source-file="index.tsx" />
  </Box>;